import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'placeholder-card',
  imports: [SkeletonModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class PlaceholderCard {
  @Input() template: string = 'lines';
}
